import { render, staticRenderFns } from "./EmployeeRoles.vue?vue&type=template&id=34f105df"
import script from "./EmployeeRoles.vue?vue&type=script&lang=ts"
export * from "./EmployeeRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports